<template>
  <el-dialog
    :close-on-click-modal="false"
    :title="title"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
    width="480px"
    append-to-body
  >
    <section>
      <section class="tablePage">
        <!-- 表格 -->
        <section class="tableBox show-table-border">
          <el-table v-loading="tableData.loading" :data="tableData.data">
            <el-table-column
              v-for="(item, index, key) in tableData.title"
              :key="key"
              :prop="item.prop"
              :label="item.label"
              align="center"
            />
          </el-table>
        </section>
      </section>
      <qx-custom-form
        @sub="sub"
        :noSubBtn="true"
        ref="customForm"
        :formData="formData"
        labelWidth="146px"
      />
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="customFormPost" :loading="subLoading"
        >确 定</el-button
      >
    </section>
  </el-dialog>
</template>

<script>
import {
  saveOrUpdateUserSalaryTemplate,
} from 'api/archives';
export default {
  data () {
    return {
      title: '',
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        title: [ // 表头
          {
            prop: 'startNum',
            label: '开始里程（KM）',
          },
          {
            prop: 'endNum',
            label: '结束里程（KM）',
          },
          {
            prop: 'price',
            label: '里程单价（元/KM）',
          },
        ],
        data: [ // 表格内容
        ],
      },
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      salaryPattern: '',
      salaryPatternName: '',
      merLoading: false, // 商户选项loading中
      originData: {},
      formData: {
        form: [
          {
            label: '请填写模板名称',
            value: 'templateName',
            type: 'input',
            width: '284px',
            placeholder: '请输入',
          },
        ],
        rules: { // 表单验证规则
          templateName: [
            { required: true, message: '请填写模板名称', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {

    /**
     * @param {Object} item 修改的项
     * @param {String} salaryPattern 工资类型
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item, salaryPattern) {
      let salaryPatternName = '';
      let tableDataTitle = [];
      if (salaryPattern === '2') {
        salaryPatternName = '里程';
        tableDataTitle = [
          { prop: 'startNum', label: '开始里程（KM）' },
          { prop: 'endNum', label: '结束里程（KM）' },
          { prop: 'price', label: '里程单价（元/KM）' },
        ];
      } else if (salaryPattern === '3') {
        salaryPatternName = '按趟';
        tableDataTitle = [
          { prop: 'startNum', label: '开始趟数' },
          { prop: 'endNum', label: '结束趟数' },
          { prop: 'price', label: '按趟单价(元/趟)' },
        ];
      }
      this.tableData.title = tableDataTitle;
      this.tableData.data = item;
      this.salaryPattern = salaryPattern;
      this.salaryPatternName = salaryPatternName;
      this.title = salaryPatternName + '工资保存模板';
      this.originData = item;
      this.dialogFormVisible = true; // 打开弹窗
      this.$refs.customForm && this.$refs.customForm.reset();
    },

    customFormPost () {
      this.$refs.customForm.sub();
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      let fieldList = [];
      if (this.tableData.data && this.tableData.data.length) {
        fieldList = this.tableData.data.map((item, index) => {
          console.log(item);
          item.sortId = `${index + 1}`;
          return item;
        });
      }
      this.subLoading = true;
      const templateName = this.$refs.customForm.getVal('templateName');
      const res = await saveOrUpdateUserSalaryTemplate({
        tId: '',
        templateName,
        salaryPattern: this.salaryPattern,
        fieldList: JSON.stringify(fieldList),
      });
      this.subLoading = false;
      if (!res.failed) {
        this.dialogFormVisible = false; // 关闭弹窗
        this.$message({
          type: 'success',
          message: '保存成功',
        });
        this.$emit('sub');
      }
    },
  },
};
</script>

<style scoped lang="scss">
</style>

